// removed by extract-text-webpack-plugin
module.exports = {"root":"FieldCheckbox__root__2FaGy","input":"FieldCheckbox__input__UBLy9","box":"FieldCheckbox__box__2-8p8","checked":"FieldCheckbox__checked__2gCL_","unchecked":"FieldCheckbox__unchecked__Y4sSa","product":"FieldCheckbox__product__3Pk6O","text":"FieldCheckbox__text__3Uf2h","productContent":"FieldCheckbox__productContent__3F3BR","productTexts":"FieldCheckbox__productTexts__2G3J5","label":"FieldCheckbox__label__1wHQ4","checkboxWrapper":"FieldCheckbox__checkboxWrapper__16Fxs","price":"FieldCheckbox__price__3xqkI","emoji":"FieldCheckbox__emoji__1DAXi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FieldCheckboxProduct/FieldCheckbox.css
// module id = 1787
// module chunks = 0